import React from 'react';
import { ErrorBoundary } from '@/app/components/ErrorBoundary';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/query-client';
import { Toaster } from '@geely/ui';

import { LandingPage } from '@/app/pages/LandingPage';
import { BookingPage } from '@/app/pages/BookingPage';
import { LookupAppointmentPage } from '@/app/pages/LookupAppointmentPage';
import { ConfirmBookingPage } from '@/app/pages/ConfirmBookingPage';

export default function App() {
  return (
    <ErrorBoundary fallback={<p>Ocorreu um erro inesperado. Recarregue a página.</p>}>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/booking" element={<BookingPage />} />
          <Route path="/booking/confirm" element={<ConfirmBookingPage />} />
          <Route path="/lookup" element={<LookupAppointmentPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </QueryClientProvider>
    </ErrorBoundary>
  );
}
